var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chatbot',{attrs:{"alerts":_vm.alerts,"translations":_vm.translations,"code":_vm.code,"market":_vm.market,"cardUrl":_vm.customerData.cardUrl,"prevent-unload":_vm.preventUnload,"show-chatbot":_vm.showChatbot},on:{"close":_vm.closeChat}})
}
var staticRenderFns = []

export { render, staticRenderFns }